import { DomainBase } from "./DomainBase";

export class CurrencyDenominationAssignment extends DomainBase {
    constructor() {
        super();
        this.Currency = null; //Currenc CLass
        this.CurrencyDenominations = []; //List<CurrencyDenomination>
    }
}